/*@ngInject*/
const ReassignSubmissionRepository = function (baseRepository, $timeout, $q) {

    angular.extend(this, baseRepository);

    this.reassignSubmissions = function (submissionParams) {
        const url = '/rest/Submission/bulkReassign';
        const defer = $q.defer();

        this.post(url, submissionParams).then((result) => {
            defer.resolve({
                successCount: result.successCount,
                errorList: result.submissionIdsInError,
                totalRequested: result.totalProcessed
            });
        });


        return defer.promise;
    };
};

angular.module('gw-um-submission-grid')
    .service('reassignSubmissionRepository', ReassignSubmissionRepository);
